import {
  getCompliancePortSearchData,
  getVesselVoyageList,
  getPortCallList,
  updateAlternateVoygage,
  portcallOrphan
} from "@/common/service/apiaggregator/apiAgreegatorService";

import { toLuxonDate } from "@/common/utils/generic/dateHelper.js";
import { convertToSortedData } from "@/common/utils/generic/commonHelper.js";

const removeDuplicateObject = data => {
  const portData = [];
  data.forEach(element => {
    let tempItem = { label: "", value: "", name: "" };
    tempItem.label = element.cityName;
    tempItem.value = element.countryName;
    tempItem.name = element.cityCode;
    portData.push(tempItem);
  });
  const filteredPortData = Array.from(portData.reduce((map, obj) => map.set(obj.name, obj), new Map()).values());
  const dataPortCity = [];
  filteredPortData.forEach(element => {
    let item = { label: "", value: "", name: "" };
    item.label = element.label + "," + element.value;
    item.value = element.label + "," + element.value;
    item.name = element.name;
    dataPortCity.push(item);
  });
  return dataPortCity;
};

const changeFormat = i => {
  if (state.dateRangeSelected[i] !== null) {
    const { day, month, year } = toLuxonDate(state.dateRangeSelected[i]).c;
    return `${day}/${month}/${year}`;
  }
};

const removeDuplicateVessel = data => {
  const vesselList = new Set();
  data.forEach(e => {
    const voyages = e.voyage.split(",");
    voyages.forEach(v => vesselList.add(v.trim()));
  });

  return [...vesselList];
};

const state = {
  vesselList: [],
  voyageList: [],
  portCityList: [],
  siteCodeList: [],
  portCallList: [],
  fullCityList: [],
  vesselListLoader: false,
  portCityListLoader: false,
  portCallListLoader: false,
  portOrphanListLoader: false,
  updateVoyageLoader: false,
  updateVoyageError: null,
  vesselListError: null,
  portCityListError: null,
  portCallListError: null,
  vesselCode: "",
  countrySelected: "",
  countryNameSelected: "",
  dateRangeSelected: {},
  portCitySelected: "",
  siteCodeSelected: "",
  vesselCodeSelected: "",
  vesselNameSelected: "",
  vesselVoyageSelected: ""
};

const mutations = {
  setVesselList(state, result) {
    state.vesselList = result;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setUserSelection(state, param) {
    const { type, value } = param;
    state[`${type}Selected`] = value;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setPortCityList(state, value) {
    state.portCityList = value;
  },
  setComplianceType(state, value) {
    state.complianceType = value;
  },
  setVoyageList(state, result) {
    state.voyageList = result;
  },
  setVesselCode(state, value) {
    state.vesselCode = value;
  },
  setPortCallList(state, value) {
    state.portCallList = value;
  },
  setSiteCodeList(state, value) {
    state.siteCodeList = value;
  },
  setFullCityList(state, value) {
    state.fullCityList = value;
  }
};

const actions = {
  async fetchOrphan({ commit }, params) {
    commit("setLoadingState", { type: "portOrphanList", value: true });
    try {
      let rawData,
        data = [];
      rawData = await portcallOrphan(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "portOrphanList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      if (data && data.bolNumbers) {
        const bolDetails = [];
        for (const item of data.bolNumbers) {
          let tempItem = {
            refreshed: false,
            bol: item
          };
          bolDetails.push(tempItem);
        }
        data.bolDetails = bolDetails;
      }

      state.portCallList[params.index].orphanBills = data;

      commit("setErrorState", { type: "portOrphanList", error: "" });
      commit("setLoadingState", { type: "portOrphanList", value: false });
    } catch (error) {
      commit("setErrorState", { type: "portOrphanList", error });
      commit("setLoadingState", { type: "portOrphanList", value: false });
    }
  },
  async fetchVesselList({ commit }, params) {
    commit("setVesselList", []);
    commit("setLoadingState", { type: "vesselList", value: true });
    try {
      let rawData,
        data = [];
      const { countryCode, cityCode, territories } = params;
      const queryParams = {
        countryCode,
        cityCode,
        vesselCode: "",
        fromDate: changeFormat(0) ? changeFormat(0) : "",
        toDate: changeFormat(1) ? changeFormat(1) : ""
      };
      if (territories) {
        queryParams["territories"] = territories;
      }
      rawData = await getVesselVoyageList(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "vesselList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      commit("setVesselList", data);
      commit("setErrorState", { type: "vesselList", error: "" });
      commit("setLoadingState", { type: "vesselList", value: false });
    } catch (error) {
      commit("setVesselList", []);
      commit("setErrorState", { type: "vesselList", error });
      commit("setLoadingState", { type: "vesselList", value: false });
    }
  },
  async fetchVoyageTypeList({ commit }, params) {
    commit("setVoyageList", []);
    commit("setLoadingState", { type: "voyageList", value: true });
    try {
      let rawData,
        data = [];
      const { countryCode, cityCode, vesselCode } = params;

      const queryParams = {
        countryCode,
        cityCode,
        vesselCode,
        fromDate: changeFormat(0) ? changeFormat(0) : "",
        toDate: changeFormat(1) ? changeFormat(1) : ""
      };
      rawData = await getVesselVoyageList(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "voyageList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      data = removeDuplicateVessel(data).sort();

      commit("setVoyageList", data);
      commit("setErrorState", { type: "voyageList", error: "" });
      commit("setLoadingState", { type: "voyageList", value: false });
    } catch (error) {
      commit("setVoyageList", []);
      commit("setErrorState", { type: "voyageList", error });
      commit("setLoadingState", { type: "voyageList", value: false });
    }
  },
  async fetchPortCityList({ commit }, countryObj) {
    commit("setPortCityList", []);
    commit("setLoadingState", { type: "portCityList", value: true });
    try {
      // const { search, countryCode } = params;
      let rawData,
        data = [];
      rawData = await getCompliancePortSearchData(countryObj, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "compliancePortList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      commit("setFullCityList", data);
      const portData = removeDuplicateObject(data);

      commit("setPortCityList", convertToSortedData(portData));
      commit("setErrorState", { type: "portCityList", error: "" });
      commit("setLoadingState", { type: "portCityList", value: false });
    } catch (error) {
      commit("setPortCityList", []);
      commit("setErrorState", { type: "portCityList", error });
      commit("setLoadingState", { type: "portCityList", value: false });
    }
  },
  async fetchPortCallList({ commit }) {
    commit("setPortCallList", []);
    commit("setLoadingState", { type: "portCallList", value: true });
    try {
      let rawData,
        data = [];
      var vesselVoyg = "";
      if (!state.vesselVoyageSelected || state.vesselVoyageSelected === null) {
        vesselVoyg = "";
      } else if (state.vesselVoyageSelected.voyage) {
        vesselVoyg = state.vesselVoyageSelected.voyage;
      } else {
        vesselVoyg = state.vesselVoyageSelected;
      }
      const queryParams = {
        cityCode: state.portCitySelected ? state.portCitySelected : "",
        countryCode: state.countrySelected ? state.countrySelected : "",
        fromDate: changeFormat(0) ? changeFormat(0) : "",
        toDate: changeFormat(1) ? changeFormat(1) : "",
        siteCode: state.siteCodeSelected ? state.siteCodeSelected : "",
        vesselCode: state.vesselCodeSelected ? state.vesselCodeSelected : "",
        voyage: vesselVoyg ? vesselVoyg : ""
      };
      rawData = await getPortCallList(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "compliancePortList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        // In portcall screen, Notification data should'nt display.
        // It is not handled in backend , so it is Handling in UI
        const notificationList = [
          "Bay Plan",
          "Presentation Notification",
          "Vessel Arrival Notification",
          "Vessel Departure Notification",
          "Vessel Pre Arrival Notification",
          "Vessel Pre Departure Notification"
        ];

        data = await rawData.json();
        data = data.filter(portCallData => !notificationList.includes(portCallData.type));
      }
      for (const item of data) {
        item.orphanBills = {};
        switch (item.siteCallStatus) {
          case "ACTUALISED":
            item.arrivalStatus = "Actual";
            item.departureStatus = "Actual";
            break;
          case "SCHEDULED":
            item.arrivalStatus = "Schedule";
            item.departureStatus = "Schedule";
            break;
          case "ARRIVAL HAS BEEN ACTUALIZED":
            item.arrivalStatus = "Actual";
            item.departureStatus = "Schedule";
            break;
        }
      }

      if (data.length === 0) {
        commit("setErrorState", { type: "portCallList", error: { hasError: "Empty Array" } });
      } else {
        commit("setErrorState", { type: "portCallList", error: "" });
      }

      commit("setPortCallList", data);
      commit("setLoadingState", { type: "portCallList", value: false });
    } catch (error) {
      commit("setPortCallList", []);
      commit("setErrorState", { type: "portCallList", error });
      commit("setLoadingState", { type: "portCallList", value: false });
    }
  },
  async updateAlternateVoygage({ commit, dispatch }, params) {
    commit("setManualStatus", []);
    commit("setLoadingState", { type: "updateVoyage", value: true });
    try {
      let rawData,
        data = [];
      rawData = await updateAlternateVoygage(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updateVoyage",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      dispatch("fetchPortCallList");
      commit("setManualStatus", data);
      commit("setErrorState", { type: "updateVoyage", error: "" });
      commit("setLoadingState", { type: "updateVoyage", value: false });

      return data;
    } catch (error) {
      commit("setManualStatus", []);
      commit("setErrorState", { type: "updateVoyage", error });
      commit("setLoadingState", { type: "updateVoyage", value: false });
    }
  },
  fetchSiteCodeList({ commit }, portValue) {
    const portData = [];
    state.fullCityList.forEach(element => {
      if (element.siteCode && portValue === element.cityCode) {
        let tempItem = { label: "", value: "", name: "" };
        tempItem.label = element.siteCode;
        tempItem.value = element.siteCode;
        tempItem.name = element.siteCode;
        portData.push(tempItem);
      }
    });
    const filteredPortData = Array.from(portData.reduce((map, obj) => map.set(obj.name, obj), new Map()).values());
    const dataPortCity = [];
    filteredPortData.forEach(element => {
      let item = { label: "", value: "", name: "" };
      item.label = element.label;
      item.value = element.value;
      item.name = element.name;
      dataPortCity.push(item);
    });
    commit("setSiteCodeList", convertToSortedData(dataPortCity));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
